import { UI, ErrorBoundaryTypes, Stack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

export interface RedemptionErrorProps extends ErrorBoundaryTypes.Props {}

export const RedemptionError: React.FC<ErrorBoundaryTypes.Props> = ({ onRefresh, ...props }) => {
  return (
    <Stack maxW="350px" alignSelf="center" py={Spacing['stack.xxxl']}>
      <UI.ErrorBoundary
        onRefresh={onRefresh}
        errorTitle="Ops, Algo deu errado!"
        errorMessageProps={{ textAlign: 'center' }}
        refreshText="RECARREGAR"
        refreshButtonCustomProps={{
          variant: 'textLink',
          rightIcon: (
            <UI.Icon name="Refresh" size="xxs" color={Color['brand.tertiary.principal']} />
          ),
        }}
        {...props}
      />
    </Stack>
  );
};
